<template>
  <div class="content has_breadcrumb studentList" v-loading="loading">
    <base-breadcrumb
      style="position: fixed; background-color: #fff"
      :data="[
        {
          routeName: 'locations',
          name: user.schoolName
        },
        {
          routeName: 'commbook',
          name: 'Commbook'
        },
        {
          name: `${firstName} ${$route.query.lastName}`
        }
      ]"
      slot="breadcrumb"
    />

    <GgPage pageType="1" title="Commbook" class="commbook">
      <div class="main-container">
        <div class="content">
          <div class="content-header">
            <p class="title">{{ $route.query.firstName }} {{ $route.query.lastName }}</p>
            <gg-create-button @click="toCreate" width="132px" label="Create" />
          </div>
          <div class="search" v-if="dataList.length > 0 || inputData">
            <div class="crm-input">
              <el-input v-model="inputData" @change="blurInput" placeholder="Search"> </el-input>

              <span v-if="!inputData" @click="blurInput" class="iconfont iconall_view_search" />

              <span v-if="inputData" @click="clearInput" class="iconfont iconClose_24px" />
            </div>
          </div>
          <div class="lists" v-if="dataList.length > 0">
            <a
              class="list"
              :href="toDetailHref(item)"
              @click.left.exact.prevent="toDetail(item)"
              :class="{ listRed: isRedTest(item) }"
              v-for="item in dataList"
              v-if="item.title"
            >
              <div class="list-flx">
                <p class="list-dot"></p>
                <el-tooltip
                  popper-class="customer-number-tooltip-popover table-tooltip"
                  :content="item.title"
                  placement="top"
                  :visible-arrow="false"
                >
                  <p class="list-name">{{ item.title }}</p>
                </el-tooltip>
                <p class="list-type">{{ item.topic }}</p>
              </div>

              <p class="list-date">
                {{ timeFormat(item.modifyTime) || timeFormat(item.createTime) }}
              </p>
            </a>
          </div>
          <div class="lists listsEmpty" v-else>
            <div slot="empty" style="text-align: center">
              <div
                style="
                  width: 213px;
                  text-align: center;
                  border-radius: 50%;
                  margin-bottom: 12px;
                  line-height: 200px;
                "
              >
                <img style="width: 100%" :src="require('@/assets/images/products/noData.svg')" />
              </div>
              <p style="font-size: 22px; color: #5f6368" v-if="inputData">No results found.</p>
              <p style="font-size: 22px; color: #5f6368" v-else>No conversation yet.</p>
            </div>
          </div>
          <div class="pages" v-if="dataList.length > 0">
            <edoovo-pagination
              slot="pagination"
              @size-change="_pageSizeChange"
              @current-change="_pageChange"
              :current-page="queryParams.current"
              :page-size="queryParams.size"
              :total="pagesTotal"
            />
          </div>
        </div>
      </div>
    </GgPage>
    <el-dialog
      :show-close="false"
      style="background: rgba(0, 0, 0, 0); box-shadow: none"
      :visible.sync="isShowRecipientsView"
      width="1140px"
    >
      <recipientsView
        :studentId="queryParams.studentId"
        v-if="isShowRecipientsView"
        @onCancel="isShowRecipientsView = false"
        @onSave="onRecipientsSave"
      />
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Ajax } from '@/common'
import { routeHref, listState } from '@/common/nav-state'
import moment from 'moment/moment'
import recipientsView from '@/views/commbook/components/recipients.vue'

// URL 读出的 current/size 只接受正整数；垃圾值回退默认值，保证内存值与请求体是 number
function toPageInt(value, fallback) {
  const n = Number(value)
  return Number.isInteger(n) && n > 0 ? n : fallback
}

export default {
  components: {
    recipientsView
  },
  data() {
    return {
      name: '',
      inputData: '',
      isShowRecipientsView: false,
      firstName: '',
      loading: false,
      queryParams: {
        size: 20,
        current: 1,
        keywords: '',
        studentId: ''
      },
      dataList: [],
      pagesTotal: 0
    }
  },
  created() {
    // 列表态以 URL 为准；缺失的默认键只回填一次（router.replace）。
    // 身份键（studentId）与展示标签（firstName/lastName）不在列表态键内，push 合并语义原样保留。
    const state = listState.defaultsFrom(this.$router, this.$route, {
      current: '1',
      size: '20',
      keywords: ''
    })
    this._seedFromQuery(state)
    this._navState = this._normalizeNavState(state)
    this._navIdentity = this._identityOf()
    this.getMsgData()
  },
  watch: {
    '$route.query': {
      deep: true,
      handler() {
        // 浏览器前进/后退复用组件或换学生：URL 与本页最近导航不一致时按 URL 重新播种并重查
        this._resyncFromRoute()
      }
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.user
    }),
    messageClass() {
      return {
        'md-invalid': this.hasErrorMessages
      }
    }
  },
  methods: {
    isRedTest(item) {
      let data = false
      if (item.isRead === 0) {
        data = true
      }
      if (item.responseDTOList) {
        item.responseDTOList.forEach((it) => {
          if (it.isRead === 0) {
            data = true
          }
        })
      }

      return data
    },
    // 单一来源：toDetail(push) 与 toDetailHref(中键/复制链接) 共用同一 location，避免双份 query 漂移
    _detailRoute(row) {
      return {
        name: 'commbookStudentResponse',
        query: {
          id: row.id,
          studentId: this.$route.query.studentId,
          firstName: this.$route.query.firstName,
          lastName: this.$route.query.lastName
        }
      }
    },
    toDetail(row) {
      this.$router.push(this._detailRoute(row))
    },
    // 防御式：走 routeHref，resolve 缺失/返回 undefined 都安全
    toDetailHref(row) {
      return routeHref(this.$router, this._detailRoute(row))
    },
    timeFormat(date) {
      if (!date) {
        return '-'
      }
      return moment.utc(date).local().format('DD/MM/YYYY, hh:mm A')
    },
    onRecipientsSave() {
      this.getMsgData()
      this.isShowRecipientsView = false
    },
    toCreate() {
      this.isShowRecipientsView = true
    },
    _pageSizeChange(size) {
      this.queryParams.size = size
      this._pushList({ size: size })
      this.getMsgData()
    },
    _pageChange(page) {
      this.queryParams.current = page
      this._pushList({ current: page })
      this.getMsgData()
    },
    blurInput() {
      this.queryParams.keywords = this.inputData
      this.queryParams.current = 1
      this._pushList({ keywords: this.inputData, current: 1 })
      this.getMsgData()
    },
    clearInput() {
      this.inputData = ''
      this.queryParams.keywords = this.inputData
      this.queryParams.current = 1
      this._pushList({ keywords: this.inputData, current: 1 })
      this.getMsgData()
    },
    // 列表 URL 状态的可比对键（studentId 是身份键，不参与）
    _stateKeys() {
      return ['keywords', 'current', 'size']
    },
    _identityOf() {
      return String(this.$route.query.studentId || '')
    },
    // 缺失/null 键折叠为 ''，保证 push 产生的“删键”与读取侧可比
    _normalizeNavState(map) {
      const out = {}
      this._stateKeys().forEach((key) => {
        const v = map[key]
        out[key] = v === undefined || v === null ? '' : String(v)
      })
      return out
    },
    _sameNavState(a, b) {
      return this._stateKeys().every((key) => a[key] === b[key])
    },
    // 自身导航统一入口：push 后记录本页最近一次 URL 状态，供 $route 监听识别自身导航
    _pushList(patch) {
      const query = listState.push(this.$router, this.$route, patch)
      this._navState = this._normalizeNavState(query)
    },
    // 以 URL 状态重建列表内存状态（created 与前进/后退复用共用）
    _seedFromQuery(state) {
      this.queryParams.keywords = String(state.keywords || '')
      // 搜索框回显跟随 URL（改写披露：旧实现输入框跨前进/后退残留，现与 URL 同口径）
      this.inputData = this.queryParams.keywords
      this.queryParams.current = toPageInt(state.current, 1)
      this.queryParams.size = toPageInt(state.size, 20)
    },
    _resyncFromRoute() {
      const state = listState.read(this.$route, this._stateKeys(), {
        current: '1',
        size: '20',
        keywords: ''
      })
      const navState = this._normalizeNavState(state)
      const identity = this._identityOf()
      if (this._sameNavState(navState, this._navState) && identity === this._navIdentity) return
      this._navState = navState
      this._navIdentity = identity
      this._seedFromQuery(state)
      this.getMsgData()
    },
    getMsgData() {
      this.queryParams.studentId = this.$route.query.studentId
      this.queryParams.schoolId = this.user.locationId
      this.queryParams.userId = this.user.userId
      this.loading = true
      return Ajax.post('/commbook/title/getNewList', this.queryParams).then((res) => {
        this.loading = false
        let { records, total } = res.data
        this.pagesTotal = total
        this.dataList = records.reverse()
        // for (let i = records.length - 1; i >= 0; i--) {
        //   this.dataList.unshift(records[i]);
        // }
      })
    }
  }
}
</script>

<style scoped lang="less">
.has_breadcrumb {
  height: 100%;
  //min-width: 1360px;
  overflow-y: hidden;
}

.commbook {
  //padding-top: 0;
}
.main-container {
  overflow-y: hidden;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow-x: auto;
  background-color: #fff;
  padding: 0 0 48px;
  flex-direction: column;

  .content {
    width: 100%;
    .pages {
      padding-top: 16px;
    }
    .listsEmpty {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 40px;
    }
    .lists {
      overflow-y: auto;
      height: calc(100vh - 368px);
      //background-color: red;
      width: 100%;

      .list {
        cursor: pointer;
        width: 100%;
        border-bottom: 1px solid #e0e0e0;
        height: 72px;
        display: flex;
        align-items: center;
        padding: 0 20px;
        justify-content: space-between;
        // 锚点化后保持与原 div 一致：去下划线、继承颜色
        text-decoration: none;
        color: inherit;
        &-flx {
          display: flex;
          width: calc(100% - 160px);
          align-items: center;
        }
        &-dot {
          width: 6px;
          height: 6px;
          background-color: #ea4335;
          border-radius: 50%;
          opacity: 0;
          margin-right: 20px;
        }
        &-name {
          color: #202124;
          font-family: Roboto;
          font-size: 14px;
          margin-right: 4px;
        }
        &-type {
          height: 20px;
          line-height: 20px;
          padding: 0 4px;
          border-radius: 10px;
          background: #e8f0fe;
          color: #1a73e8;
          font-size: 12px;
        }
        &-date {
          color: rgba(0, 0, 0, 0.5);
          font-size: 14px;
          font-family: Roboto;
        }
        &:hover {
          background-color: #eeeeee;
        }
        .list-name {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          max-width: calc(100% - 160px);
        }
      }
      .listRed {
        .list-dot {
          opacity: 1;
        }
        .list-name {
          font-weight: 700;
        }
      }
    }
    &-header {
      width: 100%;
      height: 65px;
      border-bottom: 1px solid #e0e0e0;
      padding: 0 8px;
      justify-content: space-between;
      display: flex;
      .title {
        padding-top: 8px;
        color: #202124;
        font-family: OpenSans-Bold;
        font-size: 22px;
      }
    }
  }
  .search {
    width: 280px;
    padding: 20px 0;
    .el-input {
      width: 280px;
    }
  }
  .crm-input {
    //margin-right: 28px;
    position: relative;

    //background-color: #F5F8FA;

    .iconfont {
      color: #0091ae;
      cursor: pointer;
      position: absolute;
      top: 10px;
      right: 5px;
      font-size: 20px;
    }
    .iconClose_24px {
      color: #5f6368;
    }
  }
}
</style>

<style lang="less">
.studentList {
  .el-dialog {
    background-color: rgba(0, 0, 0, 0);
    box-shadow: none;
  }

  .edoovo-pagination {
    color: #5f6368;
    font-size: 14px;
    font-family: Roboto;
  }
}
.main-container {
  .search {
    width: 280px;
    padding: 20px 0;
    .el-input {
      width: 280px;
      .el-input__inner {
        height: 40px;

        background-color: #f5f8fa;
        border-color: #cbd6e2;
      }
    }
  }
}
</style>
